import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useWorkgroupInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const WorkgroupAutocomplete = ({ onChange, workgroupFilters={}, MDInputProps={}, initialOption=null, value, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [workgroupSearch, setWorkgroupSearch] = useState("");
    const workgroupSearchQuery = useWorkgroupInfiniteQuery({search: workgroupSearch, order_by: "name", ...workgroupFilters});
    const workgroups = workgroupSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []
    const options = initialOption?.id ? [initialOption, ...workgroups.filter((w) => w.id !== initialOption.id)] : workgroups;

    // If no workgroups are found, use the default selected workgroup
    const selected = options.find((w) => w.id === value) ?? null;

    const workgroupOptions = selected ? [
        selected,
        ...workgroups.filter((w) => selected?.id !== w.id),
    ] : options;

    const handleWorkgroupSearch = debounce((value) => {
        setWorkgroupSearch(value);
    }, 300);

    return <Autocomplete
        options={workgroupOptions}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        getOptionLabel={(workgroup) => workgroup.name}
        value={selected}
        loading={workgroupSearch.isFetching}
        onChange={(e, value) => onChange(value?.id)}
        onClose={() => handleWorkgroupSearch("")}
        ListboxProps={{onScroll: getScrollHandler(workgroupSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleWorkgroupSearch(e.target.value)}
                     variant="standard"
                     label={t('workgroupsAutocomplete.label')}
                     placeholder={t('workgroupsAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={workgroupSearchQuery} params={params} /> ),
                     }}
                     {...MDInputProps}
            />
        )}
        {...props}
    />
}

export default WorkgroupAutocomplete;